import api from "../api";

export const getCountriesRequest = () => {
  return api.get(`/Countries`);
};

export const getCountrнRequest = (id: string) => {
  return api.get(`/Countries/${id}`);
};
